/* eslint class-methods-use-this: "off" */
import { isExpandableGridModel } from "../ExpandableGridModel.js";
import KeyHandler from "../KeyHandler.js";
class TreeKeyHandler extends KeyHandler {
  onDown(event, grid) {
    switch (event.key) {
      case 'Enter':
      case ' ':
        {
          return this.handleExpandKey(event, grid);
        }
      default:
        break;
    }
    return false;
  }
  handleExpandKey(event, grid) {
    var selectedRanges = grid.state.selectedRanges;
    if (selectedRanges.length === 1) {
      var range = selectedRanges[0];
      if (range.startRow === range.endRow && range.startColumn === range.endColumn) {
        if (!grid.metrics) throw new Error('grid.metrics not set');
        var model = grid.props.model;
        var row = range.startRow,
          column = range.startColumn;
        if (row != null) {
          var modelRow = grid.getModelRow(row);
          if ((column === 0 || column == null) && isExpandableGridModel(model) && model.isRowExpandable(modelRow)) {
            grid.toggleRowExpanded(row);
            return true;
          }
        }
      }
    }
    return false;
  }
}
export default TreeKeyHandler;
//# sourceMappingURL=TreeKeyHandler.js.map